import * as React from "react";
const SvgUsersPlus = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.965 21c0-.918 0-1.658.04-2.259.043-.61.13-1.153.344-1.668a5.04 5.04 0 0 1 2.724-2.724c.515-.214 1.058-.302 1.668-.343.601-.041 1.341-.041 2.259-.041h4a1.035 1.035 0 0 1 0 2.07H8c-.946 0-1.604 0-2.118.035-.505.035-.796.1-1.017.19a2.97 2.97 0 0 0-1.604 1.605c-.092.22-.156.512-.19 1.017-.036.514-.036 1.172-.036 2.118a1.035 1.035 0 0 1-2.07 0m17 0v-1.965H16a1.035 1.035 0 0 1 0-2.07h1.965V15a1.035 1.035 0 0 1 2.07 0v1.965H22a1.035 1.035 0 0 1 0 2.07h-1.965V21a1.035 1.035 0 0 1-2.07 0m-5.5-14a2.965 2.965 0 1 0-5.93 0 2.965 2.965 0 0 0 5.93 0m4.5 0c0-1.243-.765-2.31-1.854-2.75a1.035 1.035 0 0 1 .778-1.919 5.037 5.037 0 0 1 0 9.338 1.035 1.035 0 0 1-.778-1.919A2.97 2.97 0 0 0 16.965 7m-2.43 0a5.035 5.035 0 1 1-10.07 0 5.035 5.035 0 0 1 10.07 0"
}));
export default SvgUsersPlus;
//# sourceMappingURL=UsersPlus.js.map